import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';

function UpdateSupplier() {
    const { id } = useParams(); // or pass as prop
    const [formData, setFormData] = useState({
        classified_id: '',
        supplier_name: '',
        providers_of: '',
        contact_person: '',
        address: '',
        city: '',
        tehsil: '',
        district: '',
        state: '',
        pincode: '',
        mobile_no: '',
        phone_no: '',
        email: '',
        website: '',
        isActive: true
    });

    const [classifiedList, setClassifiedList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [successMessage, setSuccessMessage] = useState('');
    const [errors, setErrors] = useState({});

    // Fetch supplier + classified list
    useEffect(() => {
        const fetchData = async () => {
            try {
                const [classifiedRes, supplierRes] = await Promise.all([
                    axios.get('https://backend-zkgn.onrender.com/api/classified'),
                    axios.get(`https://backend-zkgn.onrender.com/api/suppliers/${id}`)
                ]);
                setClassifiedList(classifiedRes.data);
                setFormData(supplierRes.data);
            } catch (err) {
                console.error('Error loading data:', err);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [id]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const validate = () => {
        const errs = {};
        let valid = true;

        if (!formData.classified_id) {
            errs.classified_id = 'Classified is required';
            valid = false;
        }

        if (!formData.supplier_name) {
            errs.supplier_name = 'Supplier name is required';
            valid = false;
        }

        if (formData.email && !/\S+@\S+\.\S+/.test(formData.email)) {
            errs.email = 'Invalid email';
            valid = false;
        }

        if (formData.pincode && !/^\d{6}$/.test(formData.pincode)) {
            errs.pincode = 'Pin code must be 6 digits';
            valid = false;
        }

        setErrors(errs);
        return valid;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;

        try {
            await axios.put(`https://backend-zkgn.onrender.com/api/suppliers/${id}`, formData);
            setSuccessMessage('Supplier updated successfully!');
            setTimeout(() => setSuccessMessage(''), 3000);
        } catch (err) {
            console.error('Update error:', err);
            alert('Update failed!');
        }
    };

    if (loading) return <div className="text-center my-5">Loading...</div>;

    return (
        <div className="container mt-5">
            <h2 className="mb-4">Edit Supplier</h2>

            {successMessage && (
                <div className="alert alert-success text-center">{successMessage}</div>
            )}

            <form onSubmit={handleSubmit} className="shadow p-4 bg-light rounded">
                <div className="row g-3">
                    {/* Classified Dropdown */}
                    <div className="col-md-6">
                        <label className="form-label">Classified</label>
                        <select
                            className="form-select"
                            name="classified_id"
                            value={formData.classified_id}
                            onChange={handleChange}
                        >
                            <option value="">Select Classified</option>
                            {classifiedList.map(c => (
                                <option key={c.id} value={c.id}>
                                    {c.classified_name}
                                </option>
                            ))}
                        </select>
                        {errors.classified_id && <small className="text-danger">{errors.classified_id}</small>}
                    </div>

                    {/* Supplier Name */}
                    <div className="col-md-6">
                        <label className="form-label">Supplier Name</label>
                        <input
                            type="text"
                            className="form-control"
                            name="supplier_name"
                            value={formData.supplier_name}
                            onChange={handleChange}
                        />
                        {errors.supplier_name && <small className="text-danger">{errors.supplier_name}</small>}
                    </div>

                    {/* Providers Of */}
                    <div className="col-md-6">
                        <label className="form-label">Providers Of</label>
                        <input
                            type="text"
                            className="form-control"
                            name="providers_of"
                            value={formData.providers_of}
                            onChange={handleChange}
                        />
                    </div>

                    {/* Contact Person */}
                    <div className="col-md-6">
                        <label className="form-label">Contact Person</label>
                        <input
                            type="text"
                            className="form-control"
                            name="contact_person"
                            value={formData.contact_person}
                            onChange={handleChange}
                        />
                    </div>

                    {/* Address */}
                    <div className="col-md-6">
                        <label className="form-label">Address</label>
                        <textarea
                            className="form-control"
                            name="address"
                            rows={2}
                            value={formData.address}
                            onChange={handleChange}
                        />
                    </div>

                    {/* City */}
                    <div className="col-md-6">
                        <label className="form-label">City</label>
                        <input
                            type="text"
                            className="form-control"
                            name="city"
                            value={formData.city}
                            onChange={handleChange}
                        />
                    </div>

                    {/* Tehsil / District / State / Pin */}
                    <div className="col-md-4">
                        <label className="form-label">Tehsil</label>
                        <input
                            type="text"
                            className="form-control"
                            name="tehsil"
                            value={formData.tehsil}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="col-md-4">
                        <label className="form-label">District</label>
                        <input
                            type="text"
                            className="form-control"
                            name="district"
                            value={formData.district}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="col-md-4">
                        <label className="form-label">State</label>
                        <input
                            type="text"
                            className="form-control"
                            name="state"
                            value={formData.state}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="col-md-4">
                        <label className="form-label">Pin Code</label>
                        <input
                            type="text"
                            className="form-control"
                            name="pincode"
                            value={formData.pincode}
                            onChange={handleChange}
                        />
                        {errors.pincode && <small className="text-danger">{errors.pincode}</small>}
                    </div>

                    {/* Mobile / Phone / Email / Website */}
                    <div className="col-md-4">
                        <label className="form-label">Mobile No</label>
                        <input
                            type="text"
                            className="form-control"
                            name="mobile_no"
                            value={formData.mobile_no}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="col-md-4">
                        <label className="form-label">Phone No</label>
                        <input
                            type="text"
                            className="form-control"
                            name="phone_no"
                            value={formData.phone_no}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="col-md-6">
                        <label className="form-label">Email</label>
                        <input
                            type="email"
                            className="form-control"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                        />
                        {errors.email && <small className="text-danger">{errors.email}</small>}
                    </div>

                    <div className="col-md-6">
                        <label className="form-label">Website</label>
                        <input
                            type="text"
                            className="form-control"
                            name="website"
                            value={formData.website}
                            onChange={handleChange}
                        />
                    </div>

                    {/* Status */}
                    <div className="col-12">
                        <label className="form-label">
                            <input
                                type="checkbox"
                                name="isActive"
                                checked={formData.isActive}
                                onChange={handleChange}
                                className="form-check-input me-2"
                            />
                            Active
                        </label>
                    </div>
                </div>

                <div className="text-center mt-4">
                    <button type="submit" className="btn btn-success px-4">
                        Update Supplier
                    </button>
                </div>
            </form>
        </div>
    );
}

export default UpdateSupplier;
